import Vue from 'vue'
import Vuex from 'vuex'
import Site from './content.js'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  	siteReady: false,
  	showLoader: true,
  	showMenu: false,
    viewIndex: 0,
    viewTransitioning: false,
    views: [
		{ slideIndex: 0, transitioning: false},
		{ slideIndex: 0, transitioning: false},
		{ slideIndex: 0, transitioning: false},
		{ slideIndex: 0, transitioning: false},
		{ slideIndex: 0, transitioning: false},
		{ slideIndex: 0, transitioning: false},
    ]
  },
	mutations: {
		updateViewIndex: function(state, newIndex) { 
			if(state.viewTransitioning){
				return state;
			}
			let oldIndex = state.viewIndex
			let newState = {viewIndex: newIndex, views: state.views, viewTransitioning: true}
			newState.views[oldIndex].transitioning = true;
			console.log("UPDATE VIEW", newState.views[oldIndex].slideIndex)
			return Object.assign(state, newState)
		},
		updateSlideIndex: function(state, newIndex) { 
			if(state.viewTransitioning){
				return state;
			}
			let dir = newIndex > state.views[state.viewIndex].slideIndex ? 1 : -1
			console.log("UPDATE SLIDE")
			// console.log(newIndex, state.viewIndex)
			if((newIndex < 0) && state.viewIndex === 0){
				//return state the same
				return state.views[state.viewIndex].slideIndex;
			} else if((newIndex >= Site.pages[state.viewIndex].slides.length) || (newIndex < 0)){
				//return to previous view
				// let newState = {viewIndex: state.viewIndex + dir, views: state.views}
				// newState.views[state.viewIndex].transitioning = true;
				// return newState;
				// return Object.assign(state, newState)
				return state.showMenu = true;
			} /*else if((newIndex >= Site.pages[state.viewIndex].slides.length)){
				console.log("WAT3")
			}*/else {
				// console.log("WAT4")
				//return new slide
				let newState = {viewIndex: state.viewIndex, views: state.views, viewTransitioning: true}
				newState.views[state.viewIndex].slideIndex = newIndex;
				return Object.assign(state, newState);
				// return state.views[state.viewIndex].slideIndex = newIndex; 
			}
		},
		updateViewTransitioning: function(state) {
			let newState = {viewIndex: state.viewIndex, views: state.views, viewTransitioning: true}
			newState.views[state.viewIndex].transitioning = true;
			return Object.assign(state, newState);
			// return state.views[state.viewIndex].transitioning = true;
		},
		clearTransitioning: function(state) {
			let oldView = state.views.findIndex(view => {
				return view.transitioning
			})

			if(oldView == -1){
				return Object.assign(state, {showLoader: false, viewTransitioning: false})
				// return state.showLoader = false;
			}

			// console.log("SET OLD VIEW SLIDE TO ZERO")
			let newViewState = {slideIndex: 0, transitioning: false}
			let newState = {views: state.views, viewTransitioning: false}
			newState.views[oldView].slideIndex = 0;// = newViewState
			newState.views[oldView].transitioning = false;

			return Object.assign(state, newState)


			// return state.views.map((view) => {
			// 	return view.transitioning = false;
			// })
		},
		toggleMenu: function(state) {
			return state.showMenu = !state.showMenu
		},
		makeSiteReady: function(state) {
			return state.siteReady = true
		}
	}
});